<template>
  <div class="content" v-fastclick="()=>{imClick()}">
    <img :src="chatImg">
    <span> {{ text || '联系客服' }}</span>
  </div>
</template>

<script>
import { getUser } from '@utils/auth';
import { env } from '@utils';

export default {
  props: {
    text: String,
    chatImg: {
      type: String,
      default() {
        return 'https://coolcdn.igetcool.com/p/2023/9/0062c547ddaafbb62beb8b3644168fce.png?_28x28.png';
      }
    }
  },
  data() {
    return {
      userInfo: null
    };
  },
  created() {
    this.userInfo = getUser();
    if (this.userInfo) {
      window.qimoClientId =  {
        userId: `${ JSON.parse(localStorage.getItem('IGetCool-USER-Info')).uid }`, // 自定义用户的唯一id，不能传空字符串、null、中文，id由字母大小写、数字及'-'和 '_'组成
        priority: false, // 是否优先进线设置，非必填，值为boolean类型的true或false
        nickName: `${ JSON.parse(localStorage.getItem('IGetCool-USER-Info')).phone }`, // 自定义用户昵称，定义用户昵称则userId必传
        customField: { // 扩展字段，json对象，对象中的key-value都自定义
          '手机号': `${ JSON.parse(localStorage.getItem('IGetCool-USER-Info')).phone }`,
          'uid': `${ JSON.parse(localStorage.getItem('IGetCool-USER-Info')).uid }`
        }
      };
      let secScript = document.createElement('script');
      secScript.setAttribute('type', 'text/javascript');
      secScript.setAttribute('src', 'https://webchat.7moor.com/javascripts/7moorInit.js?accessId=7b3019f0-c57b-11e9-9f01-8969b6bbf727&autoShow=false&language=ZHCN');
      secScript.setAttribute('async', 'async');
      document.body.insertBefore(secScript, document.body.lastChild);
    }
  },
  methods: {
    imClick() {
      if (this.userInfo) {
        qimoChatClick();
      } else {
        if (env.isApp) {
          this.$emit('toAppLogin');
        } else {
          const search = location.search;
          const redirect = location.pathname;
          this.$router.replace({ path: `/mall/login${search ? `${search}&` : '?'}redirect=${redirect}` });
        }
      }
    }
  }
};
</script>

<style lang="stylus" scoped>
.content
  display flex
  flex-direction column
  justify-content center
  align-items center
  width 50px
  height 40px
  border-radius 12px
  background-color white
  z-index 100
  cursor pointer
  img
    width 18px
    height 18px
  span
    font-size 10px
    color #41414D
    margin-top 2px
</style>
